import { render, staticRenderFns } from "./filesdata.vue?vue&type=template&id=c5a6cc1a&"
import script from "./filesdata.vue?vue&type=script&lang=js&"
export * from "./filesdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports